/**
 * Universal AI event types that are the same for ALL games
 * These events represent AI agent states and actions, not game-specific events
 */

export enum AIEventType {
  // Speaking states
  SPEAKING_START = 'ai-speaking:start',
  SPEAKING_STOP = 'ai-speaking:stop',
}

export interface AIEvent {
  type: AIEventType;
  data?: unknown;
  timestamp?: string;
}

// Helper function to create AI events
export function createAIEvent(type: AIEventType, data?: unknown): AIEvent {
  return {
    type,
    data,
    timestamp: new Date().toISOString(),
  };
}
